<div class="panel panel-default">
  <div class="panel-heading">
    <label class="btn btn-default" (click)="toggleExpanded()">
      <fa-icon
        [icon]="faAngleDoubleRight"
        [flip]="collapsed ? 'horizontal' : undefined"
      ></fa-icon>
    </label>
  </div>
  <div
    class="options-list"
    h3ScrollEnabler
    h3TrackScrollEvents="tag_option_list"
  >
    <h3-tag-option-items [collapsed]="collapsed"></h3-tag-option-items>
  </div>
</div>
